export default {
    index: {
        listagem_empresas: 'Listado de Empresas',
        empresa_nao_encontrada: 'No se encontraron empresas',
        criar_empresa: 'crear Empresa',
        editar: 'Editar',
        nome: 'Nombre',
        apelido: 'Apellido',
        fornecedor: 'Proveedor'
    },
    form: {
        empresa_principal: 'Empresa Principal',
        importar: 'Importar',
        importar_vs: 'Importación de Veus Saúde',
        importar_empresa_vs: 'Empresa Importadora de Veus Saúde',
        informacoes: 'Información',
        nome: 'Nombre',
        nome_descricao: 'Nombre de la Empresa',
        mnemonico: 'Mnemotécnico',
        mnemonico_descricao: 'Mnemotécnico de la Empresa',
        id_solicitacao: 'Solicitar Identificación',
        id_solicitacao_descricao: 'Solicitud de ID de Empresa a RNDS',
        cnpj_empresa_descricao: 'Empresa SOLO NÚMEROS CNPJ',
        cnes_empresa_descricao: 'Empresa CNES',
        veus_id_descricao: 'Identificación de la Empresa en Veus Saúde',
        pesquisar: 'Buscar',
        empresa_criada_sucesso: '¡Empresa creada con éxito!',
        empresa_atualizada_sucesso: '¡Empresa actualizada con éxito!',
        provider: 'Proveedor',
        controle_qualidade: 'Control de Calidad',
        usuario: 'Usuario',
        usuario_descricao: 'Usuario de la empresa en el sistema de control de calidad.',
        senha: 'Contraseña',
        senha_descricao: 'Contraseña de la empresa en el sistema de control de calidad.'
    }
}